<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取认识的人列表</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			获取当前设备可识别的人员列表
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public String SKFaceGetPersonList(int StartIndex, int EndIndex);</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">（1）StartIndex：认识的人列表开始索引值（第一个为0）</p>
             <p class="doc_main_p">（2）EndIndex：认识的人列表结束索引值</p>
        </p>
        <h3 class="doc_main_h3">返回值</h3>
        <pre class="doc_main_pre"><code class="doc_main_code">String类型，所选索引范围内认识的人列表，json格式，例如：
{
    "PersonSum":27,
    "Persons":[
        {
            "Person_id":"551230",
            "Person_Name":"王某某",
            "Person_HeadUrl":"http://skfrm.cn/Uploads/9257871.jpg",
            "Birth":"1994-09-27",
            "Gender":1,
            "Groups":[
                {
                    "Group_Id":"3910",
                    "Group_Path":"注册人员（根目录）/盛开互动/"
                }
            ]
        },
        {
            "Person_id":"551231",
            "Person_Name":"徐某某",
            "Person_HeadUrl":"http://skfrm.cn/Uploads/8900628.jpg",
            "Birth":"1987-01-22",
            "Gender":2,
            "Groups":[
                {
                    "Group_Id":"3910",
                    "Group_Path":"注册人员（根目录）/盛开互动/"
                }
            ]
        },
        {
            "Person_id":"551423",
            "Person_Name":"李某某",
            "Person_HeadUrl":"http://skfrm.cn/Uploads/646155783.jpg",
            "Birth":"1993-01-18",
            "Gender":2,
            "Groups":[
                {
                    "Group_Id":"3910",
                    "Group_Path":"注册人员（根目录）/盛开互动/"
                }
            ]
        }
    ]
}</code></pre>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">String personList= skFaceSDKLive.SKFaceGetPersonList(0, 2);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Android','视频接口','获取认识的人列表'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/skfacesdklive/voideinitiali/VoidePeopleselect.vue